import { Heading, Container, Stack } from '@chakra-ui/react'
import { NotPermitted } from '@components/Placeholders/NotPermitted'
import { InvitationsIssued } from '@features/organisations/components/Invitations/InvitationsIssued'
import { IssueInvitation } from '@features/organisations/components/Invitations/IssueInvitation'
import { OrgMembersTable } from '@features/organisations/components/members/OrgMembersTable'
import {
  CheckPermissionsWrapper,
  Operations,
  Permission,
} from '@lib/permissions'
import { RESOURCE_ID } from '@lib/permissions/Resource'
import { createFileRoute, useParams } from '@tanstack/react-router'

const issueInvitationPermission = new Permission(
  RESOURCE_ID.org_invitation,
  Operations.Read
)

const ListOrgMembersRoute = () => {
  const { orgId } = useParams({ from: '/_auth/orgs/$orgId/members' })
  return (
    <Container maxW={'75rem'}>
      <Stack spacing={7}>
        <OrgMembersTable orgId={orgId} />
        <Heading size={'md'}>Invite new members</Heading>
        <CheckPermissionsWrapper
          permissions={[issueInvitationPermission]}
          failureComponent={<NotPermitted />}
        >
          <IssueInvitation orgId={orgId} />
          <Heading size={'md'}>Issued Invitations</Heading>
          <InvitationsIssued orgId={orgId} />
        </CheckPermissionsWrapper>
      </Stack>
    </Container>
  )
}

export const Route = createFileRoute('/_auth/orgs/$orgId/members')({
  component: ListOrgMembersRoute,
  beforeLoad: () => ({ getTitle: () => 'Members' }),
  loader: () => ({
    crumb: 'Members',
  }),
})
